<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li>Configuración de Beneficios</li>
            </ul>
            <h2>Configurar Beneficios</h2>
        </div>
    </div>
</div>

<div class="features-area pb-70 animate__animated animate__fadeIn">
    <div class="features-container">
        <div class="row m-5 centered-features">
            <!-- Beneficios Agrupados -->
            <div class="col-lg-3 col-sm-6 col-md-6" style="position: static;">
                <div class="single-features-box" (click)="toggleBeneficios()">
                    <div class="icon">
                        <i class="fas fa-medal"></i> <!-- Espacio para tu icono -->
                    </div>
                    <h3>Beneficios</h3>
                    <p>Gestión integral de beneficios</p>
                    <div class="dropdown-options" *ngIf="showBeneficios">
                        <a routerLink="/tramites-listado" class="btn btn-primary">Listado de Beneficios</a>
                        <a routerLink="/tramite-alta" class="btn btn-success">Nuevo Beneficio</a>
                    </div>
                </div>
            </div>
        
            <!-- Categorías Agrupadas -->
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-box" (click)="toggleCategorias()">
                    <div class="icon">
                        <i class="fas fa-tags"></i> <!-- Espacio para tu icono -->
                    </div>
                    <h3>Categorías</h3>
                    <p>Gestión de categorías para beneficios</p>
                    <div class="dropdown-options" *ngIf="showCategorias">
                        <a routerLink="/listado-categoria" class="btn btn-primary">Listado de Categorías</a>
                        <a routerLink="/alta-categoria" class="btn btn-success">Nueva Categoría</a>
                    </div>
                </div>
            </div>
        
            
            <!-- <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-box" (click)="toggleNoticias()">
                    <div class="icon">
                        <i class="fas fa-newspaper"></i>
                    </div>
                    <h3>Noticias</h3>
                    <p>Gestión de contenido informativo</p>
                    <div class="dropdown-options" *ngIf="showNoticias">
                        <a routerLink="/listado-noticia" class="btn btn-primary">Listado de Noticias</a>
                        <a routerLink="/alta-noticia" class="btn btn-success">Nueva Noticia</a>
                    </div>
                </div>
            </div> -->
        
            
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-box">
                    <div class="icon">
                        <i class="fas fa-paperclip"></i>
                    </div>
                    <h3><b>Adjuntos</b></h3>
                    <p>Configuración de adjuntos</p>
                    <a routerLink="/adjuntos-configuracion" class="btn btn-warning">
                        Ir a Adjuntos
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>